<template>
  <div class="pta-admin">
    <div class="page-titles border-bottom">
      <h3>Limited Partners // People
        <span class="card-subtitle" v-if="investor_contacts">{{trans('general.total_result_found',{'count' : investor_contacts.total})}}</span>
        <span class="card-subtitle" v-else>{{trans('general.no_result_found')}}</span>
      </h3>
      <sort-by class="pull-right" :order-by-options="orderByOptions" :sort-by="filterInvestorContactForm.sort_by" :order="filterInvestorContactForm.order" @updateSortBy="value => {filterInvestorContactForm.sort_by = value}"  @updateOrder="value => {filterInvestorContactForm.order = value}"></sort-by>
      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
    </div>
    <div class="container-fluid p-20" style="font-size: 0.625em;">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <div class="card border-bottom pta-filter" v-if="showFilterPanel">
              <div class="card-body p-4">
                <h4 class="card-title">{{trans('general.filter')}}</h4>
                <div class="row">
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="first_name">{{trans('investor_contact.first_name')}}</label>
                      <input class="form-control" id="first_name" name="first_name" v-model="filterInvestorContactForm.first_name">
                    </div>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="last_name">{{trans('investor_contact.last_name')}}</label>
                      <input class="form-control" id="last_name" name="last_name" v-model="filterInvestorContactForm.last_name">
                    </div>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="last_name">Label</label>
                      <select class="form-control" v-model="filterInvestorContactForm.label" name="active">
                        <option value="">All</option>
                        <option v-for="(label, index) in labels" :key="label.name">
                          {{ label.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!--   <div class="col-6 col-sm-3">
                     <div class="form-group">
                       <label for="country">Country</label>
                       <input class="form-control" id="country" name="country" v-model="filterInvestorContactForm.country">
                     </div>
                   </div>-->
                 </div>
               <!--<button class="btn btn-danger btn-sm pull-right" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button> -->
              </div>
            </div>
          </transition>
          <transition name="fade" v-if="hasPermission('create-user')">
            <div class="card border-bottom" v-if="showCreatePanel">
              <div class="card-body p-4">
                <form @submit.prevent="submit" @keydown="investor_contactForm.errors.clear($event.target.name)" autocomplete="off">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="row">
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('investor_contact.name')}}</label>
                            <input class="form-control" type="text" value="" v-model="investor_contactForm.name" name="name" :placeholder="trans('investor_contact.name')">
                            <show-error :form-name="investor_contactForm" prop-name="name"></show-error>
                          </div>
                        </div>
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('investor_contact.contact_person')}}</label>
                            <input class="form-control" type="text" value="" v-model="investor_contactForm.contact_person" name="contact_person" :placeholder="trans('investor_contact.contact_person')" autocomplete="off">
                            <show-error :form-name="investor_contactForm" prop-name="contact_person"></show-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                  <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                </form>
              </div>
            </div>
          </transition>
          <div class="card" v-if="investor_contacts.total">
            <div class="card-body">
              <div class="table-responsive" v-if="hasPermission('list-user') && investor_contacts.total">
                <table class="table table-hover pta-table-sort">
                  <thead>
                  <tr>
                    <th scope="col" @click.prevent="sortBy('label')">Label</th>
                    <th scope="col" @click.prevent="sortBy('first_name')">First&nbsp;name</th>
                    <th scope="col" @click.prevent="sortBy('last_name')">{{trans('investor_contact.last_name')}}</th>
                    <th scope="col" @click.prevent="sortBy('job_title')">Job&nbsp;Title</th>
                    <th scope="col" @click.prevent="sortBy('phone')">{{trans('investor_contact.phone')}}</th>
                    <th scope="col" @click.prevent="sortBy('email')">{{trans('investor_contact.email')}}</th>
                    <th scope="col" @click.prevent="sortBy('company')">Company</th>
                    <th scope="col" @click.prevent="sortBy('opens')">Opens</th>
                    <th scope="col" @click.prevent="sortBy('clicks')">Clicks</th>
                    <th scope="col" @click.prevent="sortBy('last_activity')">Last&nbsp;Activity</th>
                    <th scope="col" class="table-option">{{trans('general.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="investor_contact in investor_contacts.data">
                    <td style="font-size:12px;width:100px;" v-text="investor_contact.label"></td>
                    <td v-text="investor_contact.first_name"></td>
                    <td v-text="investor_contact.last_name?investor_contact.last_name:'-'"></td>
                    <td v-text="investor_contact.job_title"></td>
                    <td class="pta-phonenumbers">
                      <a :href="'tel:'+phone" v-for="phone in investor_contact.phone_work">{{ phone }}</a>
                      <a class="pta-phonenumber-org" :href="'tel:'+phone" v-for="phone in investor_contact.phone_org">{{ phone }}</a>
                    </td>
                    <td v-text="investor_contact.email_work?investor_contact.email_work:'-'"></td>
                    <td v-text="investor_contact.investor?investor_contact.investor.name:'-'"></td>
                    <td>0</td>
                    <td>0</td>
                    <td>-</td>
                    <td class="table-option">
                      <div class="btn-group">
                        <router-link :to="`/account/investors/${investor_contact.investor_id}/contacts/${investor_contact.id}`" class="btn btn-info btn-sm" v-tooltip="trans('investor_contact.view_investor_contact')"><i class="fas fa-arrow-circle-right"></i></router-link>
                        <!-- <router-link :to="`/account/investor-contacts/${investor_contact.id}`" class="btn btn-info btn-sm" v-tooltip="trans('investor_contact.view_investor_contact')"><i class="fas fa-arrow-circle-right"></i></router-link> -->
                        <!-- <a href="#" class="btn btn-info btn-sm" v-tooltip="trans('investor_contact.view_investor_contact')"><i class="fas fa-arrow-circle-right"></i></a> -->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
             <pagination-record :page-length.sync="filterInvestorContactForm.page_length" :records="investor_contacts" @updateRecords="getInvestorContacts"></pagination-record>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import switches from 'vue-switches'
import vSelect from 'vue-multiselect'
import dateRangePicker from '../../components/date-range-picker'
import sortBy from '../../components/sort-by'

export default {
  components: {switches,vSelect,dateRangePicker,sortBy},
  data() {
    return {
      showCreatePanel: false,
      investor_contacts: {
        total: 0,
        data: []
      },
      filterInvestorContactForm: {
        last_name: '',
        first_name: '',
        label: '',
        country: '',
        sort_by : 'first_name',
        order: 'asc',
        page_length: 100
      },
      showFilterPanel: true,
      orderByOptions: [
        {
          value: 'last_name',
          translation: i18n.investor_contact.last_name
        },
        {
          value: 'created_at',
          translation: i18n.investor_contact.created_at
        }
      ],
      labels : [
        {
          id: 1,
          name: "Close Investor"
        },
        {
          id: 2,
          name: "Known Investor"
        },
        {
          id: 3,
          name: "Not an Investor"
        },
        {
          id: 4,
          name: "Do not contact"
        },
        {
          id: 5,
          name: "Colleague Known"
        },
        {
          id: 6,
          name: "UNSUBSCRIBED"
        },
        {
          id: 5,
          name: "Left the firm"
        },
        {
          id: 6,
          name: "CLOSE BUT LEFT FIRM"
        }
      ],
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/account/dashboard');
    }   
    this.getInvestorContacts();
  },
  methods: {
    sortBy(sort_by){
      if(sort_by==this.filterInvestorContactForm.sort_by){
        this.filterInvestorContactForm.order = this.filterInvestorContactForm.order=='asc'?'desc':'asc';
      }else{
        this.filterInvestorContactForm.sort_by = sort_by;
      }
      this.getInvestorContacts();
    },
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getInvestorContacts(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterInvestorContactForm);
      axios.get('/api/investor-contact?show=all&page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.investor_contacts = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
  },
  watch: {
    filterInvestorContactForm: {
      handler(val){
        this.getInvestorContacts();
      },
      deep: true
    }
  },
  filters: {
    moment(date) {
      return helper.formatDate(date);
    }
  }
}
</script>
<style>
.pta-table-sort th{
  cursor: pointer;
}
</style>
